import { ReactNode } from "react";
import styled from "styled-components";
import { CenterView } from "../style/common_style";

const Container = styled(CenterView)<{ $background: string }>`
  width: 100%;
  height: 100dvh;
  font-family: var(--font-Pretendard-Regular);
  background-color: ${(props) => props.$background || "#2d2d2d"};
  color: ${(props) => (props.$background ? "#2d2d2d" : "#ffffff")};
  overflow: hidden;

  /* 드래그 금지 */
  user-select: none;
`;
const ScrollArea = styled.div<{ $isScroll: string }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: scroll;
  overflow: ${(props) => (props.$isScroll === "none" ? "hidden" : "auto")};
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const ConBox = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  max-width: 500px;
`;

interface Layout {
  children: ReactNode;
  background?: string;
  isScroll?: string;
}

const Layout_user = (props: Layout) => {
  const { children } = props;
  const background = props.background || "";
  const isScroll = props.isScroll || "";

  return (
    <Container $background={background}>
      <ScrollArea $isScroll={isScroll}>
        <ConBox>{children}</ConBox>
      </ScrollArea>
    </Container>
  );
};

export default Layout_user;
